module.exports = __webpack_public_path__ + "static/media/select-field-adicionar-cidadaos.ea583642.png";